/**
 * @generated SignedSource<<19bf34b3cf975d580f035bf998079e51>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type experienceRegistry_issueNavigator_SidebarExperienceRegistry_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_ConditionalFormattingSidebarExperience">;
  readonly " $fragmentType": "experienceRegistry_issueNavigator_SidebarExperienceRegistry_project";
};
export type experienceRegistry_issueNavigator_SidebarExperienceRegistry_project$key = {
  readonly " $data"?: experienceRegistry_issueNavigator_SidebarExperienceRegistry_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"experienceRegistry_issueNavigator_SidebarExperienceRegistry_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "experienceRegistry_issueNavigator_SidebarExperienceRegistry_project",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "main_issueNavigator_ConditionalFormattingSidebarExperience"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "982a93fe0249ea3bc1cc43a3ce04f768";

export default node;
